import { Directive, 
    Renderer2, 
    ElementRef, 
    Input,
    HostBinding } from '@angular/core';

    @Directive ({
        selector:'[hasPermission]'
    })

export class HasPermissionDirective {
    Accesos: Array<any>;
    @Input() moduleName : string;
    @HostBinding('style.backgroundColor') backgroundColor: string;

    constructor(private elementRef: ElementRef ,private renderer : Renderer2){
        this.Accesos = JSON.parse(sessionStorage.getItem('acceso'));
    }

    ngOnInit(){
        if(!this.hasPermission())
            this.elementRef.nativeElement.style.display = 'none'

    }

    hasPermission(): boolean {        
        if(this.Accesos.find(acceso => acceso.codigo == this.moduleName))
            return true;
        else
            return false;
    }


}